$('#id_search').change(function () {
  let search = `search[${$(this).val()}]`
  $('#id_numeric').attr('name', search)
})

$('#user_broadcast_notification_popup').modal({
  backdrop: 'static',
  keyboard: false,
})

$('.activate-help-contact').click(function (e) {
  e.preventDefault()
  if (window.fcWidget.isLoaded() == true) {
    window.fcWidget.open()
  } else {
    Intercom('show')
  }
})
